import { MerchantListPage } from '../types/merchantListFilters';
import { adminApi } from './index';

export const getMerchantListPageAPI = async (params: Record<string, string | number | boolean | undefined>) => {
  const response = await adminApi.api.get<MerchantListPage>('/api/v2/users/merchants/list', { params });
  return response.data;
};
